<app-label-configuration
  [title]="'P0003600.installation.filtration.programmeTitre' | translate"
  [information]="openEnSavoirPlus"
  [titleListe]="'P0003600.installation.filtration.programme' | translate"
  [description]="
    'P0003600.installation.filtration.programmeDescription' | translate
  "
  [value]="actionStack!.getValue('fsCProgrammeFiltrationAuto')"
  [liste]="
    hasProduitP00030() > 0 || hasProduitP00032() > 0
      ? P0003600ProgrammeFiltrationAuto
      : P0003600ProgrammeFiltrationAutoSans
  "
  (onPress)="
    this.actionStack!.editValue(
      P00039DataRxTxIndex.FiltrationStandard_Controle,
      'fsCProgrammeFiltrationAuto',
      $event
    );
    this.actionStack!.commit()
  "
>
</app-label-configuration>

@if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 0) {
  <app-minuterie-label
    [title]="
      'P0003600.installation.filtration.programmeTitre.0.titre' | translate
    "
    [name]="
      'P0003600.installation.filtration.programmeUsine.programmeTitre'
        | translate
    "
    [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
    [minuteInterval]="1"
    [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPHeureDepart',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-minuterie-label>
}

@if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 1) {
  <app-minuterie-label
    [title]="
      'P0003600.installation.filtration.programmeTitre.1.titre' | translate
    "
    [name]="
      'P0003600.installation.filtration.programmeUsine.programmeTitre'
        | translate
    "
    [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
    [minuteInterval]="1"
    [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPHeureDepart',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-minuterie-label>
}

@if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 2) {
  <app-minuterie-label
    [title]="
      'P0003600.installation.filtration.programmeTitre.2.titre' | translate
    "
    [name]="
      'P0003600.installation.filtration.programmeUsine.programmeTitre'
        | translate
    "
    [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
    [minuteInterval]="1"
    [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPHeureDepart',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-minuterie-label>
}

@if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 6) {
  <app-minuterie-label
    [title]="
      'P0003600.installation.filtration.programmeTitre.6.titre' | translate
    "
    [name]="
      'P0003600.installation.filtration.programmeUsine.programmeTitre'
        | translate
    "
    [value]="convertMinutesToTime(actionStack!.getValue('fsPHeureDepart'))"
    [minuteInterval]="1"
    [startDate]="this.actionStack!.getValue('fsPHeureDepart')"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPHeureDepart',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-minuterie-label>

  <app-label-configuration
    [titleListe]="
      'P0003600.installation.filtration.programmeLoiDEau.dureeAjustementLoiDEau.programmeTitre'
        | translate
    "
    [value]="actionStack!.getValue('fsPDureeAjustementLoiDEau')"
    [liste]="P0003600DureeAjustementLoiEau"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPDureeAjustementLoiDEau',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>
}

@if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 3) {
  <app-two-choices-control
    [title]="'P0003600.installation.filtration.programmePPH' | translate"
    [firstLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.day'
        | translate
    "
    [firstValue]="0"
    [secondLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.week'
        | translate
    "
    [secondValue]="1"
    [value]="actionStack!.getValue('fsPTypeHorlogePPH')"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPTypeHorlogePPH',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-two-choices-control>

  @if (this.actionStack!.getValue('fsPTypeHorlogePPH') === 0) {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingsClockScreen()"
    >
    </app-larged-link>
  } @else {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingClockWeekScreen()"
    >
    </app-larged-link>
  }

  <app-label-description
    [description]="'P00039.parameters.setting.text.clock' | translate"
  ></app-label-description>
}

@if (actionStack!.getValue('fsCProgrammeFiltrationAuto') === 4) {
  <app-two-choices-control
    [title]="'P0003600.filtration.reglage.horlogeEte' | translate"
    [firstLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.day'
        | translate
    "
    [firstValue]="0"
    [secondLabel]="
      'P00039.lighting.functionality.parameters.setting.title.clock.week'
        | translate
    "
    [secondValue]="1"
    [value]="actionStack!.getValue('fsPTypeHorlogePPE')"
    (onChange)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPTypeHorlogePPE',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-two-choices-control>

  @if (this.actionStack!.getValue('fsPTypeHorlogePPE') === 0) {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingsClockPPEScreen()"
    >
    </app-larged-link>
  } @else {
    <app-larged-link
      [name]="
        'P0003600.installation.filtration.programmePPH.horlogePicotsJoursPPH.programmeTitre'
          | translate
      "
      (onPress)="goToFunctionParametersSettingClockWeekPPEScreen()"
    >
    </app-larged-link>
  }

  <app-label-description
    [description]="'P00039.parameters.setting.text.clock' | translate"
  ></app-label-description>
}

<div class="mt-4">
  <app-switch-configuration
    [title]="
      'P0003600.installation.prevention.filtrationForceeEauChaude2424'
        | translate
    "
    [nameCustom]="
      'P0003600.installation.prevention.activationFonctionFiltration2424.smallTitle'
        | translate
    "
    [value]="actionStack!.getValue('fsPActivationFonctionFiltration2424') !== 0"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPActivationFonctionFiltration2424',
        $event ? 1 : 0
      );
      this.actionStack!.commit()
    "
  >
  </app-switch-configuration>

  @if (actionStack!.getValue('fsPActivationFonctionFiltration2424') === 1) {
    <app-label-configuration
      [titleListe]="
        'P0003600.installation.prevention.seuilTemperatureFonctionFiltration2424.smallTitle'
          | translate
      "
      [value]="
        actionStack!.getValue('fsPSeuilTemperatureFonctionFiltration2424')
      "
      [liste]="P0003600SeuilTemperatureFiltration2424()"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationStandard_Parametrage,
          'fsPSeuilTemperatureFonctionFiltration2424',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-label-configuration>
  }

  <app-label-description
    [description]="
      'P0003600.installation.prevention.activationFonctionFiltration2424.description.' +
        getTemperatureType() | translate
    "
  ></app-label-description>
</div>

<div>
  <div class="my-2">
    <div class="row">
      <div class="col">
        <ion-label class="color-medium text-uppercase">{{
          'P0003600.installation.preventiongel.typeFonctionHorsGel.title'
            | translate
        }}</ion-label>
      </div>
    </div>
  </div>

  <app-label-configuration
    [titleListe]="
      'P0003600.installation.preventiongel.typeFonctionHorsGel.smallTitle'
        | translate
    "
    [value]="actionStack!.getValue('fsPTypeFonctionHorsGel')"
    [liste]="P0003600TypeFonctionHorsGelEnum"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPTypeFonctionHorsGel',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>

  @if (hasProduitP00032() > 0 && hasProduitP00030() > 0) {
    <app-label-configuration
      [titleListe]="
        'P0003600.installation.prevention.capteurTemperatureReferenceHorsGel.smallTitle'
          | translate
      "
      [value]="actionStack!.getValue('fsICapteurTemperatureReferenceHorsGel')"
      [liste]="P0003600CapteurTemperatureEnum"
      (onPress)="
        this.actionStack!.editValue(
          P00039DataRxTxIndex.FiltrationStandard_Installation,
          'fsICapteurTemperatureReferenceHorsGel',
          $event
        );
        this.actionStack!.commit()
      "
    >
    </app-label-configuration>
  }

  <app-label-configuration
    [titleListe]="
      'P0003600.installation.prevention.seuilTemperatureReferenceHorsGel.smallTitle'
        | translate
    "
    [value]="actionStack!.getValue('fsPSeuilTemperatureFonctionHorsGel')"
    [liste]="P0003600SeuilTemperatureHorsGel()"
    (onPress)="
      this.actionStack!.editValue(
        P00039DataRxTxIndex.FiltrationStandard_Parametrage,
        'fsPSeuilTemperatureFonctionHorsGel',
        $event
      );
      this.actionStack!.commit()
    "
  >
  </app-label-configuration>

  <p class="my-3 mb-4 color-medium">
    {{
      'P0003600.installation.preventiongel.typeFonctionHorsGel.description'
        | translate
    }}
  </p>
</div>
